import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface LogoProps {
  className?: string;
  showText?: boolean;
  variant?: "full" | "symbol";
  noLink?: boolean;
  href?: string;
}

/**
 * LogoIcon - Muestra el icono institucional (símbolo solo).
 */
export function LogoIcon({ className = "" }: { className?: string }) {
  return (
    <div
      className={cn(
        "relative flex items-center justify-center overflow-hidden shrink-0",
        className,
      )}
    >
      <img
        src="/logo_vitafarma.png"
        alt="Logotipo de Vitafarma"
        className="h-7 w-auto object-contain"
      />
    </div>
  );
}

/**
 * Logo - Maneja las dos variantes de imagen: full (con texto) y symbol (solo icono).
 */
export function Logo({ className = "", variant = "full", noLink = false, href }: LogoProps) {
  const landingUrl = href || "/";

  const content = (
    <div className={cn("flex items-center", className)}>
      {variant === "full" ? (
        // Variante completa: Imagen que ya incluye el texto
        <img
          src="/logo_vitafarma_full.png"
          alt="Vitafarma | Sistema de Gestión Farmacéutica"
          className="h-7 w-auto object-contain"
          fetchPriority="high"
          width="187"
          height="28"
        />
      ) : (
        // Variante símbolo: Solo el icono
        <LogoIcon className="h-7 w-auto" />
      )}
    </div>
  );

  if (noLink) return <div className={className}>{content}</div>;

  return (
    <Link
      to={landingUrl}
      className={cn("flex items-center transition-opacity hover:opacity-90", className)}
      aria-label="Volver al panel principal"
    >
      {content}
    </Link>
  );
}
